export enum Status {
  Draft = 'draft',
  InReview = 'in_review',
  Approved = 'approved',
  Published = 'published',
  Archived = 'archived',
}

export type Nullable<T> = T | null
export type URLString = string
export type DateTimeString = string
